import React from 'react'
import './offer.css'
import { Container, Col, Row, Card, CardTitle, CardText } from 'reactstrap'

import img_1 from './images/img_1.png'
import img_2 from './images/img_2.png'
import img_3 from './images/img_3.png'
import arrow from './images/arrow.png'

var Translate = require('react-translate-component')

export default class Offer extends React.Component {
  constructor () {
    super()
    this.state = {
      width: window.innerWidth
    }
  }

  componentWillMount () {
    window.addEventListener('resize', this.handleWindowSizeChange)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleWindowSizeChange)
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth })
  }

  render () {
    return (
      <div className='offers'>
        <p className='sectionTitle'>
          <Translate content='nasza_oferta' />
        </p>
        <hr className='sectionTitleLine' />
        <p className='sectionDesc'>
          <Translate content='nasza_oferta_obejmuje' />
        </p>
        <Container>
          <Row className='offerRow'>
            <Col md='12' id='offerCol'>
              <Card alignItems='center' id='offerCard'>
                <div class='row card-body'>
                  {this.state.width < 768 && (
                    <img
                      class='col-sm-6'
                      id='offerCol'
                      src={img_1}
                      alt='elewacje'
                    />
                  )}
                  <Col sm='6' md='6' className='offerDescription'>
                    <CardTitle className='offerCardTitle'>
                      <Translate content='serwis_elewacji_aluminiowych' />
                    </CardTitle>
                    <CardText className='offerCardText '>
                      <Translate content='potrzebujesz_kompleksowego' />
                    </CardText>
                    <a
                      className='offerCardDetails '
                      href={process.env.PUBLIC_URL + '#/facades'}
                    >
                      <Translate content='szczegoly' />
                    </a>
                    <img src={arrow} alt='arrow' />
                  </Col>

                  {this.state.width > 768 && (
                    <img
                      class='col-sm-6'
                      id='offerCol'
                      src={img_1}
                      alt='elewacje'
                    />
                  )}
                </div>
              </Card>
            </Col>
          </Row>
          <Row className='offerRow'>
            <Col md='12' id='offerCol'>
              <Card alignItems='center' id='offerCard'>
                <div class='row card-body'>
                  <img
                    class='col-sm-6'
                    id='offerCol'
                    src={img_2}
                    alt='konstrukcje'
                  />
                  <Col sm='6' md='6' className='offerDescription'>
                    <CardTitle className='offerCardTitle'>
                      <Translate content='konstrukcje_aluminiowe' />
                    </CardTitle>
                    <CardText className='offerCardText '>
                      <Translate content='w_naszej_ofercie' />
                    </CardText>
                    <a
                      className='offerCardDetails '
                      href={process.env.PUBLIC_URL + '#/constructions'}
                    >
                      <Translate content='szczegoly' />
                    </a>
                    <img src={arrow} alt='arrow' />
                  </Col>
                </div>
              </Card>
            </Col>
          </Row>
          <Row className='offerRow'>
            <Col md='12' id='offerCol'>
              <Card alignItems='center' id='offerCard'>
                <div class='row card-body'>
                  {this.state.width < 768 && (
                    <img
                      class='col-sm-6'
                      id='offerCol'
                      src={img_3}
                      alt='inne'
                    />
                  )}
                  <Col sm='6' md='6' className='offerDescription'>
                    <CardTitle className='offerCardTitle'>
                      <Translate content='dodatkowe_uslugi' />
                    </CardTitle>
                    <CardText className='offerCardText '>
                      <Translate content='nasza_firma_oferuje' />
                    </CardText>
                    <a
                      className='offerCardDetails '
                      href={process.env.PUBLIC_URL + '#/other'}
                    >
                      <Translate content='szczegoly' />
                    </a>
                    <img src={arrow} alt='arrow' />
                  </Col>
                  {this.state.width > 768 && (
                    <img
                      class='col-sm-6'
                      id='offerCol'
                      src={img_3}
                      alt='inne'
                    />
                  )}
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}
